document.addEventListener('DOMContentLoaded', () => {
  const styleId = 'custom-style'; // 重複防止用のID

  const observer = new MutationObserver(() => {
    // すべての要素を走査して、shadowRootを持っているものを探す
    document.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot && !el.shadowRoot.querySelector(`#${styleId}`)) {
        const targetInside = el.shadowRoot.querySelector('.cl-calendar');
        if (targetInside) {
          injectStyle(el.shadowRoot);
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function injectStyle(shadowRoot) {
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
    .cl-event-card__date-icon {
        flex-direction:column-reverse!important
    }
    `;
    shadowRoot.appendChild(style);
    console.log('✅ Custom style injected into shadowRoot');
  }
});
